import { createI18n } from 'vue-i18n';
import ro from '../shared/i18n/ro.js';
import en from '../shared/i18n/en.js';

export const SUPPORTED_LOCALES = ['ro', 'en'] as const;
export type SupportedLocale = (typeof SUPPORTED_LOCALES)[number];

const STORAGE_KEY = 'shift.locale';

const initialLocale = (): SupportedLocale => {
  const stored = localStorage.getItem(STORAGE_KEY);
  return SUPPORTED_LOCALES.includes(stored as SupportedLocale) ? (stored as SupportedLocale) : 'ro';
};

export const i18n = createI18n({
  legacy: false,
  locale: initialLocale(),
  fallbackLocale: 'ro',
  messages: { ro, en },
});

export const setLocale = (locale: SupportedLocale): void => {
  i18n.global.locale.value = locale;
  localStorage.setItem(STORAGE_KEY, locale);
  document.documentElement.setAttribute('lang', locale);
};
